export const ACCESS_RIGHTS = {

  //#region CORE
  CORE_SECURITY_USERS: 1001,
  CORE_SECURITY_ROLES: 1002,
  CORE_SECURITY_AUDITLOGS: 1003,
  CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER: 1004,
  CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR: 1005,
  CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER: 1006,
  //#endregion

  //#region FMS
  FMS_DASHBOARD_ACCOUNTING: 3001,
  FMS_DASHBOARD_BUDGET: 3002,
  FMS_DASHBOARD_COLLECTION: 3003,
  FMS_DASHBOARD_DISBURSEMENT: 3004,

  FMS_ASSETS: 3301,

  FMS_BUDGET_BURS: 3401,
  FMS_BUDGET_GAAS: 3402,
  FMS_BUDGET_PPAS: 3403,
  FMS_BUDGET_SAROS: 3404,

  FMS_STATICDATA_ACCOUNTABLEFORMS: 3501,
  FMS_STATICDATA_ACCOUNTCLASSIFICATIONS: 3502,
  FMS_STATICDATA_ALLOTMENTSOURCEDOCUMENTTYPES: 3503,
  FMS_STATICDATA_AUTHORIZATIONCODES: 3504,
  FMS_STATICDATA_BANKS: 3505,
  FMS_STATICDATA_BANKBRANCHES: 3506,
  FMS_STATICDATA_BANKACCOUNTS: 3507,
  FMS_STATICDATA_CLIENTS: 3508,
  FMS_STATICDATA_DOCUMENTTYPES: 3509,
  FMS_STATICDATA_FUNDINGSOURCES: 3510,
  FMS_STATICDATA_FINANCINGSOURCES: 3511,
  FMS_STATICDATA_FUNDCATEGORIES: 3512,
  FMS_STATICDATA_FUNDSUBCATEGORIES: 3513,
  FMS_STATICDATA_FUNDCLUSTERS: 3513,
  FMS_STATICDATA_GENERALLEDGERS: 3514,
  FMS_STATICDATA_OBJECTCODES: 3515,
  FMS_STATICDATA_RESPONSIBILITYCENTERS: 3516,
  FMS_STATICDATA_SUBOBJECTCODES: 3517,
  FMS_STATICDATA_SUBSIDIARYLEDGERS: 3518,
  FMS_STATICDATA_TRANSACTIONTYPES: 3519,

  FMS_TRANSACTIONS_APPROPRIATIONS_VIEWER: 3601,
  FMS_TRANSACTIONS_APPROPRIATIONS_REQUESTOR: 3602,
  FMS_TRANSACTIONS_APPROPRIATIONS_APPROVER: 3603,
  FMS_TRANSACTIONS_NOTICEOFCASHALLOCATIONS_VIEWER: 3601,
  FMS_TRANSACTIONS_NOTICEOFCASHALLOCATIONS_REQUESTOR: 3602,
  FMS_TRANSACTIONS_NOTICEOFCASHALLOCATIONS_APPROVER: 3603,
  FMS_TRANSACTIONS_LDDAP_VIEWER: 3601,
  FMS_TRANSACTIONS_LDDAP_REQUESTOR: 3602,
  FMS_TRANSACTIONS_LDDAP_APPROVER: 3603,

  FMS_TRANSACTIONS_ALLOTMENTS_VIEWER: 3604,
  FMS_TRANSACTIONS_ALLOTMENTS_REQUESTOR: 3605,
  FMS_TRANSACTIONS_ALLOTMENTS_APPROVER: 3606,
  FMS_TRANSACTIONS_CASHDISBURSEMENTS_VIEWER: 3607,
  FMS_TRANSACTIONS_CASHDISBURSEMENTS_REQUESTOR: 3608,
  FMS_TRANSACTIONS_CASHDISBURSEMENTS_APPROVER: 3609,
  FMS_TRANSACTIONS_CHECKDISBURSEMENTS_VIEWER: 3610,
  FMS_TRANSACTIONS_CHECKDISBURSEMENTS_REQUESTOR: 3611,
  FMS_TRANSACTIONS_CHECKDISBURSEMENTS_APPROVER: 3612,
  FMS_TRANSACTIONS_COLLECTIONS_VIEWER: 3613,
  FMS_TRANSACTIONS_COLLECTIONS_REQUESTOR: 3614,
  FMS_TRANSACTIONS_COLLECTIONS_APPROVER: 3615,
  FMS_TRANSACTIONS_DEPOSITS_VIEWER: 3616,
  FMS_TRANSACTIONS_DEPOSITS_REQUESTOR: 3617,
  FMS_TRANSACTIONS_DEPOSITS_APPROVER: 3618,
  FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_VIEWER: 3619,
  FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_REQUESTOR: 3620,
  FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_REVIEWER: 3621,
  FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_FUNDER: 3622,
  FMS_TRANSACTIONS_DISBURSEMENTVOUCHERS_APPROVER: 3623,
  FMS_TRANSACTIONS_JOURNALENTRYVOUCHERS_VIEWER: 3624,
  FMS_TRANSACTIONS_JOURNALENTRYVOUCHERS_REQUESTOR: 3625,
  FMS_TRANSACTIONS_JOURNALENTRYVOUCHERS_APPROVER: 3626,
  FMS_TRANSACTIONS_OBLIGATIONS_VIEWER: 3627,
  FMS_TRANSACTIONS_OBLIGATIONS_REQUESTOR: 3628,
  FMS_TRANSACTIONS_OBLIGATIONS_APPROVER: 3629,
  FMS_TRANSACTIONS_ORDEROFPAYMENTS_VIEWER: 3630,
  FMS_TRANSACTIONS_ORDEROFPAYMENTS_REQUESTOR: 3631,
  FMS_TRANSACTIONS_ORDEROFPAYMENTS_APPROVER: 3632,
  FMS_TRANSACTIONS_PREPAYMENTS_VIEWER: 3633,
  FMS_TRANSACTIONS_PREPAYMENTS_REQUESTOR: 3634,
  FMS_TRANSACTIONS_PREPAYMENTS_APPROVER: 3635,

  FMS_REPORTS_CLIENTMASTERLISTREPORT: 3801,
  FMS_REPORTS_COLLECTIONSREPORT: 3802,
  FMS_REPORTS_ORDEROFPAYMENTREPORT: 3803,
  //#endregion

  //#region PEOPLESYNC
  PEOPLESYNC_DASHBOARD_EMPLOYEES: 4001,

  PEOPLESYNC_EMPLOYEES: 4101,
  PEOPLESYNC_EMPLOYEES_PERSONALINFORMATION: 4102,
  PEOPLESYNC_EMPLOYEES_MEDICALINFORMATION: 4103,
  PEOPLESYNC_EMPLOYEES_WORKINFORMATION: 4104,
  PEOPLESYNC_EMPLOYEES_SALARYINFORMATION: 4105,
  PEOPLESYNC_EMPLOYEES_BANKINFORMATION: 4106,
  PEOPLESYNC_EMPLOYEES_SERVICERECORDS: 4107,
  PEOPLESYNC_EMPLOYEES_PERSONALDATASHEET: 4108,

  PEOPLESYNC_STATICDATA_BRANCHES: 4501,
  PEOPLESYNC_STATICDATA_DEPARTMENTS: 4502,
  PEOPLESYNC_STATICDATA_EDUCATIONLEVELS: 4503,
  PEOPLESYNC_STATICDATA_EMPLOYMENTTYPES: 4504,
  PEOPLESYNC_STATICDATA_HOLIDAYTYPES: 4505,
  PEOPLESYNC_STATICDATA_LEAVETYPES: 4506,
  PEOPLESYNC_STATICDATA_NATIONALITIES: 4507,
  PEOPLESYNC_STATICDATA_PLANTILLAS: 4508,
  PEOPLESYNC_STATICDATA_POSITIONS: 4509,
  PEOPLESYNC_STATICDATA_RELATIONSHIPTYPES: 4510,
  PEOPLESYNC_STATICDATA_SALARYGRADES: 4511,
  PEOPLESYNC_STATICDATA_SALARYTYPES: 4512,
  PEOPLESYNC_STATICDATA_SCHOOLS: 4513,
  PEOPLESYNC_STATICDATA_SEPARATIONCAUSETYPES: 4514,
  PEOPLESYNC_STATICDATA_SERVICERECORDTYPES: 4515,
  PEOPLESYNC_STATICDATA_SKILLS: 4516,
  PEOPLESYNC_STATICDATA_WORKSCHEDULES: 4517,

  PEOPLESYNC_TRANSACTIONS_CHANGELOCATIONS_VIEWER: 4601,
  PEOPLESYNC_TRANSACTIONS_CHANGELOCATIONS_REQUESTOR: 4602,
  PEOPLESYNC_TRANSACTIONS_CHANGELOCATIONS_APPROVER: 4603,
  PEOPLESYNC_TRANSACTIONS_EMPLOYMENTCERTIFICATEREQUESTS_VIEWER: 4601,
  PEOPLESYNC_TRANSACTIONS_EMPLOYMENTCERTIFICATEREQUESTS_REQUESTOR: 4602,
  PEOPLESYNC_TRANSACTIONS_EMPLOYMENTCERTIFICATEREQUESTS_APPROVER: 4603,
  PEOPLESYNC_TRANSACTIONS_FILE201COPYREQUESTS_VIEWER: 4604,
  PEOPLESYNC_TRANSACTIONS_FILE201COPYREQUESTS_REQUESTOR: 4605,
  PEOPLESYNC_TRANSACTIONS_FILE201COPYREQUESTS_APPROVER: 4606,
  PEOPLESYNC_TRANSACTIONS_LEAVEREQUESTS_VIEWER: 4607,
  PEOPLESYNC_TRANSACTIONS_LEAVEREQUESTS_REQUESTOR: 4608,
  PEOPLESYNC_TRANSACTIONS_LEAVEREQUESTS_APPROVER: 4609,
  PEOPLESYNC_TRANSACTIONS_OVERTIMEREQUESTS_VIEWER: 4610,
  PEOPLESYNC_TRANSACTIONS_OVERTIMEREQUESTS_REQUESTOR: 4611,
  PEOPLESYNC_TRANSACTIONS_OVERTIMEREQUESTS_APPROVER: 4612,
  PEOPLESYNC_TRANSACTIONS_SERVICERECORDCOPYREQUESTS_VIEWER: 4613,
  PEOPLESYNC_TRANSACTIONS_SERVICERECORDCOPYREQUESTS_REQUESTOR: 4614,
  PEOPLESYNC_TRANSACTIONS_SERVICERECORDCOPYREQUESTS_APPROVER: 4615,
  PEOPLESYNC_TRANSACTIONS_TRAININGREQUESTS_VIEWER: 4616,
  PEOPLESYNC_TRANSACTIONS_TRAININGREQUESTS_REQUESTOR: 4617,
  PEOPLESYNC_TRANSACTIONS_TRAININGREQUESTS_APPROVER: 4618,
  PEOPLESYNC_TRANSACTIONS_WORKFROMHOMEREQUESTS_VIEWER: 4619,
  PEOPLESYNC_TRANSACTIONS_WORKFROMHOMEREQUESTS_REQUESTOR: 4620,
  PEOPLESYNC_TRANSACTIONS_WORKFROMHOMEREQUESTS_APPROVER: 4621,
  //#endregion

  //#region PAYFLOW
  PAYFLOW_DASHBOARD: 4001,
  //#endregion

  //#region DOCUMENT MANAGEMENT SYSTEM
  DMS_DASHBOARD: 6001,
  //#endregion

  //#region ASSET GUARD
  ASSETGUARD_ASSETS: 8101,
  ASSETGUARD_ASSETS_FILES: 8104,
  ASSETGUARD_ASSETS_LOGS: 8105,

  ASSETGUARD_DASHBOARD: 9101,

  ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_VIEWER: 9601,
  ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_REQUESTOR: 9602,
  ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_APPROVER: 9603,
  //#endregion ASSET GUARD
};
